<app-page-panel class="flex-fit"
    [showBackButton]="false"
    iconNameFontAwesome="star"
    pageTitle="Projektanlage"    
    [showBackColor]="true"
    [showDetailsButton]="false"
    [showSidepanelButton]="false"
    [showCloseButton]="true"
    [showContent]="false"
    (closeButtonClicked)="onCloseButtonClick()">
</app-page-panel>
<form (ngSubmit)="projektForm.form.valid && onSaveButtonClick()" #projektForm="ngForm">
    <mat-dialog-content class="form-content">
        <div class="form-group flex flex-col flex-stretch-self">
            <div class="flex flex-row flex-fill flex-gap-120 flex-justify">
                <div class="flex flex-row flex-fill-force flex-gap-12">
                    <mat-form-field class="flex flex-fill">
                        <mat-label>Projektname</mat-label>
                        <input matInput required placeholder="Name des Projektes" [(ngModel)]="dataAntragNeu().name" name="name">
                    </mat-form-field>
                </div>
                <div class="flex flex-row flex-fill-force flex-gap-12">
                    <mat-form-field class="flex-fill">
                        <mat-label>Projektanfang</mat-label>
                        <input matInput required [matDatepicker]="pickerProjektanfang"
                            placeholder="Projektanfang" [(ngModel)]="dataAntragNeu().projektAnfang" name="projektanfang">
                        <mat-datepicker-toggle matIconSuffix [for]="pickerProjektanfang"></mat-datepicker-toggle>                           
                        <mat-datepicker #pickerProjektanfang></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field class="flex-fill">
                        <mat-label>Projektende</mat-label>
                        <input matInput required [matDatepicker]="pickerProjektende"
                            placeholder="Projektende" [(ngModel)]="dataAntragNeu().projektEnde" name="projektende" [afterDate]="dataAntragNeu().projektAnfang">
                        <mat-datepicker-toggle matIconSuffix [for]="pickerProjektende"></mat-datepicker-toggle>                           
                        <mat-datepicker #pickerProjektende></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>                
            <mat-form-field>
                <mat-label>Projektbeschreibung</mat-label>
                <textarea matInput required rows="5" placeholder="Ausführliche Beschreibung" [(ngModel)]="dataAntragNeu().beschreibung" name="beschreibung"></textarea>
            </mat-form-field>
            <app-element-panel class="form-panel" 
                iconNameFontAwesome="star"
                pageTitle="Zuordnungen"
                [showDetailsButton]="false">

                <div class="flex flex-row flex-stretch-self flex-gap-120">
                    <div class="flex flex-col flex-fill">
                        <mat-form-field>
                            <mat-label>Controlling</mat-label>
                            <mat-select [(ngModel)]="dataAntragNeu().controllingbereichId" (ngModelChange)="controllingbereichChange($event)" name="controlling" required>
                                @for (item of dataProjektantrag().controllingbereiche; track item) {
                                    <mat-option [value]="item.controllingbereichID">{{item.name}}</mat-option>
                                }                            
                            </mat-select>                        
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Plangebiet</mat-label>
                            <mat-select [(ngModel)]="dataAntragNeu().plangebietId" (ngModelChange)="plangebietChange($event)" name="plangebiet" required>
                                @for (item of dataProjektantrag().plangebiete; track item) {
                                    <mat-option [value]="item.id">{{item.name}} ({{item.kurz}})</mat-option>
                                }                            
                            </mat-select>                        
                        </mat-form-field>
                        <mat-form-field class="form-field-remove-hint">
                            <mat-label>Quartier</mat-label>
                            <mat-select [(ngModel)]="dataAntragNeu().quartierId" name="quartier" required>
                                @for (item of getQuartiere(); track item) {
                                    <mat-option [value]="item.id">{{item.name}}</mat-option>
                                }                            
                            </mat-select>                        
                        </mat-form-field>
                    </div>
                    <div class="flex flex-col flex-fill">
                    <mat-form-field >
                            <mat-label>Klassifizierung</mat-label>
                            <mat-select [(ngModel)]="dataAntragNeu().klassifizierungId" name="klassifizierung" required>
                                @for (item of getKlassifizierungen(); track item) {
                                    <mat-option [value]="item.id">{{item.name}}</mat-option>
                                }                            
                            </mat-select>                        
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Projektmanager</mat-label>
                            <mat-select [(ngModel)]="dataAntragNeu().projektmanagerId" name="projektmanager" required>
                                @for (item of getProjektManager(); track item) {
                                    <mat-option [value]="item.id">{{item.name}} ({{item.kurz}})</mat-option>
                                }                            
                            </mat-select>                        
                        </mat-form-field>
                        <mat-form-field class="form-field-remove-hint">
                            <mat-label>Projektsteuerer</mat-label>
                            <mat-select [(ngModel)]="dataAntragNeu().projektsteuererId" name="projektsteuerer">
                                @for (item of getProjektSteuerer(); track item) {
                                    <mat-option [value]="item.id">{{item.name}} ({{item.kurz}})</mat-option>
                                }                            
                            </mat-select>                        
                        </mat-form-field>
                    </div>
                </div>
            </app-element-panel>
            <div class="flex flex-row flex-stretch-self flex-gap-120">
                <div class="flex flex-col flex-fill">
                    <mat-form-field class="form-field-remove-hint">
                        <mat-label>Kostenstelle</mat-label>
                        <input matInput [readonly]="isBauControlling()" [ngClass]="isBauControlling() ? 'form-field-readonly' : ''"
                            [(ngModel)]="dataAntragNeu().kostenstelle" name="kostenstelle">
                    </mat-form-field>
                </div>  
                <div class="flex flex-col flex-fill">
                    <mat-form-field class="form-field-remove-hint" [ngClass]="isBauControlling() ? 'form-field-readonly' : ''">
                        <mat-label>Kostengruppe</mat-label>
                        <mat-select [(ngModel)]="dataAntragNeu().kostengruppeId" name="kostengruppe" [required]="!isBauControlling()" [disabled]="isBauControlling()">
                            @for (item of getKostengruppen(); track item) {
                                <mat-option [value]="item.kostengruppeID">{{item.kostengruppeKurz}} ({{item.kostengruppeLang}})</mat-option>
                            }                            
                        </mat-select>                        
                    </mat-form-field>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button type="submit" [disabled]="!projektForm.form.valid" mat-button>Speichern</button>
        <button mat-button mat-dialog-close>Abbrechen</button>
    </mat-dialog-actions>
</form>
